// Live search: fetches Meilisearch suggestions while typing and lets you walk
// the dropdown with the arrow keys. Registered as Alpine.data('liveSearch').
export default function registerLiveSearch(Alpine) {
    Alpine.data('liveSearch', () => ({
        query: '',
        results: [],
        total: 0,
        active: -1,
        loading: false,
        open: false,
        expanded: false, // used by the header field that expands on click
        controller: null,
        searchUrl: '/zoeken',
        suggestUrl: '/api/zoeken/suggesties',

        async suggest() {
            this.active = -1;
            const q = this.query.trim();

            if (q.length < 2) {
                this.results = [];
                this.total = 0;
                this.open = false;
                return;
            }

            this.open = true;
            this.controller?.abort();
            this.controller = new AbortController();
            this.loading = true;

            try {
                const res = await fetch(`${this.suggestUrl}?q=${encodeURIComponent(q)}`, {
                    signal: this.controller.signal,
                    headers: {Accept: 'application/json'},
                });
                const data = await res.json();
                this.results = data.results || [];
                this.total = data.total ?? this.results.length;
            } catch (e) {
                /* aborted or failed — stay quiet */
            }

            this.loading = false;
        },

        // Always offer an "all results" row at the bottom when there are results
        get showAll() {
            return this.results.length > 0;
        },

        move(step) {
            if (!this.open || !this.results.length) {
                return;
            }
            const count = this.results.length + (this.showAll ? 1 : 0);
            this.active = (this.active + step + count) % count;
        },

        go(event) {
            if (this.active >= 0 && this.active < this.results.length) {
                event.preventDefault();
                window.location.href = this.results[this.active].url;
            } else if (this.active === this.results.length && this.showAll) {
                event.preventDefault();
                window.location.href = `${this.searchUrl}?q=${encodeURIComponent(this.query)}`;
            }
            // no active suggestion: let the form submit to the search page
        },
    }));
}
